<template>
  <b-overlay :show="loadingAction">
    <b-dropdown
      v-if="selectedAuctions.length > 1"
      variant="link"
      no-caret
      v-has-permission="'ED221'"
      data-cy="massive-actions"
      right
    >
      <template #button-content>
        <feather-icon
          icon="ApertureIcon"
          class="mr-3"
        />
        <span class="align-middle">Acciones</span>
      </template>
      <CheckPermission permission="ED224">
        <b-dropdown-item
          data-cy="massive-prepare"
          v-on:click="onOptionAuctionPrepare()"
        >
          <vs-icon icon="arrow_forward"/>
          Preparar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED227">
        <b-dropdown-item
          data-cy="massive-un-prepare"
          v-on:click="onOptionAuctionUnPrepare()"
        >
          <vs-icon icon="arrow_back"/>
          Dejar de preparar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED229">
        <b-dropdown-item
          data-cy="massive-publish"
          v-on:click="onOptionAuctionPublish()"
        >
          <vs-icon icon="verified_user"/>
          Publicar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED222">
        <b-dropdown-item
          data-cy="massive-cancel"
          v-on:click="onOptionAuctionCancel()"
        >
          <vs-icon icon="clear"/>
          Cancelar
        </b-dropdown-item>
      </CheckPermission>
      <CheckPermission permission="ED223">
        <b-dropdown-item
          data-cy="massive-end"
          v-on:click="onOptionAuctionEnd()"
        >
          <vs-icon icon="check_circle"/>
          Finalizar
        </b-dropdown-item>
      </CheckPermission>
    </b-dropdown>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import {
  CANCEL_STATES,
  auctionsStates,
  PREPARE_STATES,
  END_STATES,
  UN_PREPARE_STATES, PUBLISH_STATES
} from '@/febos/aduanas/auctions/views/utils/constants';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import MasivasMixin from '@/febos/global/_vue/mixins/MasivasMixin';
import {
  LLAMADA_MASIVA_ADUANA_CANCELAR_SUBASTA_BASE,
  LLAMADA_MASIVA_ADUANA_PREPARAR_SUBASTA_BASE,
  LLAMADA_MASIVA_ADUANA_FINALIZAR_SUBASTA_BASE,
  LLAMADA_MASIVA_ADUANA_DES_PREPARAR_SUBASTA_BASE, LLAMADA_MASIVA_ADUANA_PUBLICAR_SUBASTA_BASE
} from '@/febos/servicios/api/aduanas/constantes';

export default {
  components: {
    CheckPermission
  },
  mixins: [MasivasMixin],
  props: [
    'selectedAuctions'
  ],
  data() {
    return {
      loadingAction: false,
      CANCEL_STATES,
      loading: false
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    selectedAuctionsIds() {
      return this.selectedAuctions.map((batch) => batch.loteId);
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    checkAllAuctionsInStates(states) {
      return this.selectedAuctions.every((batch) => states.includes(batch.estado));
    },
    async updateAuction(request, action) {
      const payload = {
        ...request,
        ...{
          comunes: {
            ...request.comunes
          },
          payload: this.selectedAuctions.map(
            (auction) => ({
              id: auction.subastaId
            })
          )
        }
      };
      this.loadingAction = true;
      try {
        await this.sendMasiveProcess(payload);
        this.$vs.notify({
          title: 'Genial!',
          text: `Se ha solicitado la ${action} de  ${this.selectedAuctions.length} subastas,
          te enviaremos un correo con los detalles cuando esta termine.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
        this.loadingAction = false;
      } finally {
        this.loadingAction = false;
      }
    },
    onOptionCancel() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas cancelar ${this.selectedAuctions.length} subastas?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateAuction(LLAMADA_MASIVA_ADUANA_CANCELAR_SUBASTA_BASE, 'cancelación')
      });
    },
    onOptionAuctionCancel() {
      const allInStateToCancel = this.checkAllAuctionsInStates(CANCEL_STATES);
      if (allInStateToCancel) {
        this.onOptionCancel();
      } else {
        const statusNames = CANCEL_STATES.map((state) => auctionsStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden cancelar subastas en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionPrepareAuction() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas preparar ${this.selectedAuctions.length} subastas?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateAuction(LLAMADA_MASIVA_ADUANA_PREPARAR_SUBASTA_BASE, 'preparación')
      });
    },
    onOptionUnPrepareAuction() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas dejar de preparar ${this.selectedAuctions.length} subastas?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateAuction(
          LLAMADA_MASIVA_ADUANA_DES_PREPARAR_SUBASTA_BASE, 'acción dejar de preparar'
        )
      });
    },
    onOptionPublishAuction() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas publicar ${this.selectedAuctions.length} subastas?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateAuction(
          LLAMADA_MASIVA_ADUANA_PUBLICAR_SUBASTA_BASE, 'publicación'
        )
      });
    },
    onOptionAuctionPrepare() {
      const allInStateToPrepare = this.checkAllAuctionsInStates(PREPARE_STATES);
      if (allInStateToPrepare) {
        this.onOptionPrepareAuction();
      } else {
        const statusNames = PREPARE_STATES.map((state) => auctionsStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden preparar subastas en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionAuctionUnPrepare() {
      const allInStateToUnPrepare = this.checkAllAuctionsInStates(UN_PREPARE_STATES);
      if (allInStateToUnPrepare) {
        this.onOptionUnPrepareAuction();
      } else {
        const statusNames = UN_PREPARE_STATES.map((state) => auctionsStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden dejar de preparar subastas en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionAuctionPublish() {
      const allInStateToPublish = this.checkAllAuctionsInStates(PUBLISH_STATES);
      if (allInStateToPublish) {
        this.onOptionPublishAuction();
      } else {
        const statusNames = PUBLISH_STATES.map((state) => auctionsStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden publicar subastas en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    onOptionEndAuction() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas finalizar ${this.selectedAuctions.length} subastas?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateAuction(LLAMADA_MASIVA_ADUANA_FINALIZAR_SUBASTA_BASE, 'finalización')
      });
    },
    onOptionAuctionEnd() {
      const allInStateToEnd = this.checkAllAuctionsInStates(END_STATES);
      if (allInStateToEnd) {
        this.onOptionEndAuction();
      } else {
        const statusNames = END_STATES.map((state) => auctionsStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Sólo se pueden finalizar subastas en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    }
  }
};

</script>
